import FooterHeader from "./FooterHeader";
import FooterSummary from "./FooterSummary";

export default function Footer() {
  return (
    <div className="mt-16">
      <FooterHeader />
      <FooterSummary />
    </div>
  );
}
